
// import { openDB } from 'idb';

// const DB_NAME = 'codebookCacheDB';
// const STORE_NAME = 'codebookStore';
// const DB_VERSION = 2;

// // Get the database instance and ensure the store exists
// const getDB = async () => {
//   return await openDB(DB_NAME, DB_VERSION, {
//     upgrade(db) {
//       if (!db.objectStoreNames.contains(STORE_NAME)) {
//         db.createObjectStore(STORE_NAME);
//       }
//     },
//   });
// };

// // Save data to IndexedDB
// export const saveCodebookToIndexedDB = async (key, data) => {
//   try {
//     const db = await getDB();
//     await db.put(STORE_NAME, data, key);
//   } catch (err) {
//     console.error('Save IndexedDB error:', err);
//   }
// };

// // Get data from IndexedDB
// export const getCodebookFromIndexedDB = async (key) => {
//   try {
//     const db = await getDB();
//     return await db.get(STORE_NAME, key);
//   } catch (err) {
//     console.error('Get IndexedDB error:', err);
//     return null;
//   }
// };

// // Clear the entire store from IndexedDB
// export const clearCodebookFromIndexedDB = async () => {
//   try {
//     const db = await getDB();
//     if (db.objectStoreNames.contains(STORE_NAME)) {
//       const tx = db.transaction(STORE_NAME, 'readwrite');
//       await tx.objectStore(STORE_NAME).clear();
//       await tx.done;
//       console.log('IndexedDB store cleared.');
//     }
//   } catch (err) {
//     console.error('Clear IndexedDB error:', err);
//   }
// };

import { openDB } from 'idb';
import CryptoJS from 'crypto-js';

const DB_NAME = 'codebookCacheDB';
const STORE_NAME = 'codebookStore';
const DB_VERSION = 2;
const SECRET_KEY = 'your-secret-key'; // keep this safe or fetch from server

// Get the database instance and ensure the store exists
const getDB = async () => {
  return await openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    },
  });
};

// Encrypt before saving
const encryptData = (data) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
};

// Decrypt after reading
const decryptData = (ciphertext) => {
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  } catch (e) {
    console.error("Decryption failed:", e);
    return null;
  }
};

// Save encrypted data to IndexedDB
export const saveCodebookToIndexedDB = async (key, data) => {
  try {
    const db = await getDB();
    const encrypted = encryptData(data);
    await db.put(STORE_NAME, encrypted, key);
  } catch (err) {
    console.error('Save IndexedDB error:', err);
  }
};

// Get and decrypt data from IndexedDB
export const getCodebookFromIndexedDB = async (key) => {
  try {
    const db = await getDB();
    const encrypted = await db.get(STORE_NAME, key);
    if (!encrypted) return null;
    return decryptData(encrypted);
  } catch (err) {
    console.error('Get IndexedDB error:', err);
    return null;
  }
};

export const clearCodebookFromIndexedDB = async () => {
  try {
    // Completely delete the database instead of just clearing the store
    await indexedDB.deleteDatabase('codebookCacheDB');
    // console.log('✅ Entire IndexedDB "codebookCacheDB" deleted successfully');
  } catch (err) {
    console.error('❌ Error deleting IndexedDB:', err);
  }
};

 

